import React from 'react';
import { withRouter, Route, Redirect, Switch } from 'react-router';
import { Layout } from 'App/Layout';
import { TherapistDashboard } from 'TherapistDashboard';
import { MessageCenter } from 'MessageCenter';
import { PatientCareCenter } from 'PatientCareCenter';
import { ReportCenter } from 'ReportCenter';
import { HelpCenter } from 'HelpCenter';
import { Search } from 'Search';
import { RouteDefs } from '_constants';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { uiActions, userActions } from '_actions';
import { ErrorBoundary } from './ErrorBoundary';
import { MsalContext } from "@azure/msal-react";
import { history } from '_helpers';
import styles from './AppAuth.module.css'
import { CetsDialog } from './CetsDialog';


const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
];

let logoutTimer;

class AppAuth extends React.Component {
    static contextType = MsalContext;

    constructor(props) {
        super(props);
        this.handleLogoutTimer = this.handleLogoutTimer.bind(this);
        this.resetTimer = this.resetTimer.bind(this);
        this.appAuthEventListener = this.appAuthEventListener.bind(this);
    }

    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
        this.resetTimer()
        Object.values(events).forEach((item) => {
            window.removeEventListener(item, this.appAuthEventListener);
        });

        logoutTimer = undefined;
    }

    componentDidMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            if (location.pathname !== RouteDefs.loginPage.path) {
                this.props.changeRoute(location.pathname);
            }
        });

        var isAuthenticated = this.context.accounts.length > 0;

        if (!isAuthenticated || !localStorage.getItem('user') || (!this.props.selectingCompany && !this.props.masterDataLoading && !this.props.masterDataLoaded)) {
            history.push(RouteDefs.loginPage.path);
        }

        Object.values(events).forEach((item) => {
            window.addEventListener(item, this.appAuthEventListener);
        });

    }

    appAuthEventListener() {
        this.resetTimer();
        this.handleLogoutTimer();
    }

    handleLogoutTimer() {
        logoutTimer = setTimeout(() => {
            // clears any pending timer.
            this.resetTimer();
            // Listener clean up. Removes the existing event listener from the window
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, this.appAuthEventListener);
            });
            // logs out user (and quietly saves session)
            this.props.logout();
        }, this.props.logoutTimeout);
    }

    resetTimer() {
        if (logoutTimer) clearTimeout(logoutTimer);
    }

    logoutAction() {
        this.props.logout();
    }


    render() {
        return (
            <ErrorBoundary>
                {this.props.sessionLoading &&
                    <div className={styles.login_wrapper}>
                        <img alt='CORA Physical Therapy' className={styles.logo} src='./images/cora_animated.gif'></img>
                        <p>Loading...</p>
                    </div>
                }
                {!this.props.sessionLoading &&
                    <Layout>

                        {this.props.cetsMessageVisible &&
                            <CetsDialog />
                        }

                        <Switch>
                            <Route exact path={RouteDefs.therapistDashboard.path}>
                                <TherapistDashboard />
                            </Route>

                            <Route path={RouteDefs.messageCenter.path}>
                                <MessageCenter />
                            </Route>
                            <Route path={RouteDefs.patientCareCenter.path}>
                                <PatientCareCenter />
                            </Route>
                            <Route path={RouteDefs.reportCenter.path}>
                                <ReportCenter />
                            </Route>
                            <Route path={RouteDefs.helpCenter.path}>
                                <HelpCenter />
                            </Route>
                            <Route path={RouteDefs.search.path}>
                                <Search />
                            </Route>
                            <Redirect to={RouteDefs.loginPage.path} />
                        </Switch>
                    </Layout>
                }
            </ErrorBoundary>
        );
    }
}

function mapStateToProps(state) {
    let logoutTimeout = state.entities.masterData.PROPS ?
        parseInt(state.entities.masterData.PROPS['PTERO_AUTO_LOGOUT_MINUTES'].PRVALUE) * 60 * 1000 :
        20 * 60 * 1000;
    let masterDataLoaded = state.entities.masterData.loaded;
    let masterDataLoading = state.entities.masterData.loading;
    let selectingCompany = state.entities.authentication.selectingCompany;
    let hardStopEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_CETS_HARD_STOP_ENABLED'].PRVALUE === 'true' : false;

    return {
        sessionLoading: state.entities.authentication.sessionLoading,
        cetsMessageVisible: state.ui.cets.cetsMessageVisible && hardStopEnabled,
        logoutTimeout,
        masterDataLoaded,
        masterDataLoading,
        selectingCompany
    };
}


function mapDispatchToProps(dispatch) {
    return {
        changeRoute: bindActionCreators(uiActions.changeRoute, dispatch),
        logout: bindActionCreators(userActions.logout, dispatch)

    };
}

const connectedAppAuth = withRouter(connect(mapStateToProps, mapDispatchToProps)(AppAuth));
export { connectedAppAuth as AppAuth };
